import { useRegisterPushWebMutation } from '@shared/api/requests';

import { useProfileStore } from '@/shared/store/profileStore';

const VAPID_PUBLIC_KEY = import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY;

const urlBase64ToUint8Array = (base64String: string) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return new Uint8Array([...rawData].map((char) => char.charCodeAt(0)));
};

export const usePushNotifications = () => {
  const { isAuthenticated } = useProfileStore();
  const registerWebPushMutation = useRegisterPushWebMutation();

  const requestPermissionAndRegister = async () => {
    if (!isAuthenticated || !('Notification' in window)) return;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    try {
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        console.warn('Web Push not supported');
        return;
      }

      const registration = await navigator.serviceWorker.ready;
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
      });

      const body = {
        userId: '123', // заменить на реальный userId
        endpoint: subscription.endpoint,
        p256dh: subscription.getKey
          ? btoa(
              String.fromCharCode(
                ...new Uint8Array(subscription.getKey('p256dh')!)
              )
            )
          : '',
        auth: subscription.getKey
          ? btoa(
              String.fromCharCode(
                ...new Uint8Array(subscription.getKey('auth')!)
              )
            )
          : '',
        platform: 'webpush'
      };

      await registerWebPushMutation.mutateAsync({
        params: body
      });
    } catch (err) {
      console.error('Push notification registration failed', err);
    }
  };

  return { requestPermissionAndRegister };
};
